/* rj-lp: behaviour of rejuderme.com lp-chest-skinlet.js (reveal on scroll, FAQ accordion,
   before/after slideshow, mini-review dots, sticky CTA). Their dataLayer pushes and the
   expert-video player are left out; CTAs are plain links to the product page. */
(function () {
  'use strict';
  function reveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.lp-block, .lp-stagger').forEach(function (b) { b.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.lp-block').forEach(function (b) { b.classList.add('lp-reveal'); io.observe(b); });
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io2.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.lp-stagger').forEach(function (el) { io2.observe(el); });
  }
  function faq() {
    document.querySelectorAll('.lp-faq__item').forEach(function (item) {
      var btn = item.querySelector('.lp-faq__question'), ans = item.querySelector('.lp-faq__answer');
      if (!btn || !ans) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        document.querySelectorAll('.lp-faq__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var ob = o.querySelector('.lp-faq__question'), oa = o.querySelector('.lp-faq__answer');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oa) oa.style.maxHeight = '0';
        });
        if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
      });
    });
  }
  function slideshows() {
    document.querySelectorAll('.lp-slideshow').forEach(function (sh) {
      var track = sh.querySelector('.lp-slideshow__track'), slides = sh.querySelectorAll('.lp-slide'),
          dots = sh.querySelectorAll('.lp-dot'), prev = sh.querySelector('.lp-slideshow__prev'), next = sh.querySelector('.lp-slideshow__next');
      if (!track || !slides.length) return;
      function idx() { var w = slides[0].offsetWidth; return w ? Math.round(track.scrollLeft / w) : 0; }
      function update() {
        var i = idx();
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }
      function go(i) { track.scrollTo({ left: slides[0].offsetWidth * i, behavior: 'smooth' }); }
      track.addEventListener('scroll', update, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      if (prev) prev.addEventListener('click', function () { go(Math.max(0, idx() - 1)); });
      if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, idx() + 1)); });
      update();
    });
  }
  function miniDots() {
    var mini = document.querySelector('.lp-mini-reviews'), dots = document.querySelectorAll('.lp-mini-reviews__dots .lp-dot');
    if (!mini || !dots.length) return;
    function step() { var c = mini.querySelector('.lp-mini-review'); return c ? c.offsetWidth + 12 : 0; }
    function update() {
      var s = step(), i = s ? Math.round(mini.scrollLeft / s) : 0;
      i = Math.max(0, Math.min(dots.length - 1, i));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    mini.addEventListener('scroll', update, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { mini.scrollTo({ left: step() * k, behavior: 'smooth' }); }); });
    update();
  }
  function sticky() {
    var el = document.querySelector('.lp-sticky-cta');
    if (!el) return;
    var th = window.innerHeight * 0.8;
    window.addEventListener('scroll', function () { el.classList.toggle('is-visible', window.scrollY > th); }, { passive: true });
    var fin = document.querySelector('.lp-final-cta');
    if (fin && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { el.classList.toggle('is-hidden-by-final', e.isIntersecting); }); }, { threshold: 0.15 }).observe(fin);
    }
  }
  function init() { reveal(); faq(); slideshows(); miniDots(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
